import { EFeatures } from '@constants';

import { Wrapper } from './ExamGroupsRankingWidget.styles';
import { ExamGroupsWidget } from './ExamGroupsWidget';
import { RankingWidget } from './RankingWidget';

import { useTagFeatures } from '@/hooks';

export const ExamGroupsRankingWidget: React.FC = () => {
  const { canRender } = useTagFeatures();

  const showExamGroups = canRender(EFeatures.ANNOUNCEMENTS);

  return (
    <Wrapper>
      {showExamGroups && <ExamGroupsWidget />}
      <RankingWidget />
    </Wrapper>
  );
};
